export const COPY_TEXT = 'Click to Copy';
